import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import axios from "axios";
//import download from 'downloadjs';

const Preparazione_documenti_apprendistato = (props) => {

    const [value, setValue] = useState();


    function invia_mail_di_inizio_stage() {
        console.log('invia_mail_di_inizio_stage');

    }


    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')

    }

    function preparazione_documenti() {
        console.log('invia_mail_di_inizio_stage');
        const nuovo_progetto = {
            id: props.progetto._id,
            id_alunno: props.progetto.id_alunno,
            id_ditta: props.progetto.id_ditta,
            data_inizio: props.progetto.data_inizio,
            data_fine: props.progetto.data_fine
        }
        console.log(nuovo_progetto);
        axios.post('/transfer_s3/preparazione_documenti_apprendistato', nuovo_progetto)
        .then((res) => {
            console.log(res.data)
            download_docx('Apprendistato_docx')

              
            //                SET_variab_aggiorna(JSON.stringify(res.data))
        }).catch((error) => {
            console.log(error)
        });
    }


    const download_docx = (indirizzo) => {
        const cognome = props.progetto.id_alunno.cognome
        const nome = props.progetto.id_alunno.nome
        axios.get('/transfer_s3/apprendistato_docx_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null
               
//                return res.data
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };


    function download_pdf () {
        const cognome = props.progetto.id_alunno.cognome
        const nome = props.progetto.id_alunno.nome
        const indirizzo = 'Progetto_pdf'
        console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

        axios.get('/transfer_s3/progetto_pdf_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx PDF url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')
//                if (newWindow) newWindow.opener = null
               
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };






    return (
        <div>
          
            <div class="dropdown-divider"></div>

            <Dropdown.Item onClick={preparazione_documenti}>Documenti Apprenditato</Dropdown.Item>

            <Dropdown.Item onClick={download_pdf}>Download Progetto pdf</Dropdown.Item>

        </div>
    )
}
export default Preparazione_documenti_apprendistato;